import React from 'react'
import LockClosed from '@react/react-spectrum/Icon/LockClosed'

export default function LayerLock ({
    layer
}) {
    return layer.locked ? <LockClosed size="S" /> : null
}
